import { IntlShape } from 'react-intl';

import messages from '@/components/emotion-detector/messages';
import pauseIcon from 'icons/pause-filled.svg';
import playIcon from 'icons/play-filled.svg';

export function getPlayPauseIcon(isPlaying: boolean) {
	return isPlaying ? pauseIcon : playIcon;
}

export function getPlayPauseLabel(isPlaying: boolean, formatMessage: IntlShape['formatMessage']): string {
	return isPlaying ? formatMessage(messages.audioPlayerPause) : formatMessage(messages.audioPlayerPlay);
}
